export default {
    LoadingText: "準備中。。。",
    NoDataText: "データが存在しません。",
    RowsText: "行"
}